// extracted by mini-css-extract-plugin
export default {"stat-card":"PublicTreasury_stat-card__cN6w-","stats-container":"PublicTreasury_stats-container__Jl4g6"};